import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgServiceabonnement = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Serviceabonnement_svg__a"
      width={27}
      height={27}
      x={7}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M31.33 23.36a5.67 5.67 0 0 0-5.46-1.48l-7.06-7.06-.69-.69c.5-1.88 0-3.98-1.48-5.46s-3.58-1.98-5.46-1.48l3.47 3.47-3.99 3.99-3.47-3.47c-.5 1.88 0 3.98 1.48 5.46s3.58 1.98 5.46 1.48l1.74 1.74 6.02 6.02c-.5 1.88 0 3.98 1.48 5.46a5.67 5.67 0 0 0 5.46 1.48l-3.47-3.47 3.99-3.99 3.47 3.47c.5-1.88 0-3.98-1.48-5.46z"
      />
    </mask>
    <g
      fill="#F8C9E9"
      mask="url(#Serviceabonnement_svg__a)"
    >
      <path d="m-4.49 5.86 12.24 7.07L14.82.68zM7.75 12.93.68 25.18 20 20zM5.86 44.49l7.07-12.24L.68 25.18zM25.18 39.32l7.07-12.25L20 20zM20 20l-7.07 12.25 12.25 7.07zM39.32 14.82l-7.07 12.25 12.24 7.07zM34.14-4.49 14.82.68l12.25 7.07zM39.32 14.82 27.07 7.75 20 20z" />
      <path d="M-4.49 5.86.68 25.18l7.07-12.25zM5.86 44.49l19.32-5.17-12.25-7.07zM.68 25.18l12.25 7.07L20 20zM20 20l12.25 7.07 7.07-12.25zM44.49 34.14l-12.24-7.07-7.07 12.25zM20 20l7.07-12.25L14.82.68zM14.82.68 7.75 12.93 20 20zM34.14-4.49 27.07 7.75l12.25 7.07z" />
    </g>
    <path
      fill="#F29FC5"
      d="m25.92 8.25-8.01 17.36-2.79-6.52-.98-.98c-.96.25-1.98.25-2.94-.02l-1.76.76 6.06 14.14h4.66L30.59 10.4l-4.66-2.15z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgServiceabonnement);

export default ForwardRef;
